var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\t"+_vm._s(_vm.column.getLabel(_vm.value))),(_vm.isDeleted())?_c('span',{attrs:{"title":_vm.t('tables', 'This option is outdated.')}},[_vm._v(" ⚠️")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }